<template>
  <div class="assessment-mobile-placeholder">
    <ContentPlaceholders>
      <ContentPlaceholdersImg
        v-for="i in 5"
        :key="i"
        class="assessment-mobile-placeholder__card"
      />
    </ContentPlaceholders>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AssessmentMobilePlaceholder",
});
</script>

<style lang="scss" scoped>
.assessment-mobile-placeholder__card {
  margin-bottom: 8px;

  border-radius: 3px;
}
</style>
